module.exports = __webpack_public_path__ + "static/media/start-recording.2ce2a5ba.svg";